import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/store';
import routes from './routes';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

Vue.use(Router);

const router = new Router({
    //mode: "history",
    base: process.env.BASE_URL,
    routes: routes
});

Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN_FRONT,
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ['localhost', 'pvh24.ru', /^\//]
        })
    ],
    tracesSampleRate: 1.0
});

router.beforeEach((to, from, next) => {
    if (to.path !== '/login') {
        if (store.getters.isAuthenticated) {
            if (!store.state.auth.loadFromServer) {
                store.dispatch('getAuth').then(
                    response => {
                        const auth = store.state.auth;
                        if (to.meta && to.meta.roles) {
                            const routeRoles = to.meta.roles;
                            let access = false;
                            routeRoles.forEach(function(role) {
                                if (Object.prototype.hasOwnProperty.call(auth.roles, role.key)) {
                                    access = true;
                                }
                            });
                            if (access) {
                                next();
                            } else {
                                next('/forbidden');
                            }
                        } else {
                            next();
                        }
                    },
                    error => {
                        console.log(error);
                    }
                );
            } else {
                //Тут дублирование, надо бы от него избавиться
                const auth = store.state.auth;
                if (to.meta && to.meta.roles) {
                    const routeRoles = to.meta.roles;
                    let access = false;
                    routeRoles.forEach(function(role) {
                        if (Object.prototype.hasOwnProperty.call(auth.roles, role.key)) {
                            access = true;
                        }
                    });
                    if (access) {
                        next();
                    } else {
                        next('/forbidden');
                    }
                } else {
                    next();
                }
            }
        } else {
            next('/login');
        }
    } else {
        next();
    }
});

export default router;
